/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1CourseregistrationEnrollmentCancelMutationRequest,
  PostApiV1CourseregistrationEnrollmentCancelMutationResponse,
  PostApiV1CourseregistrationEnrollmentCancel400,
  PostApiV1CourseregistrationEnrollmentCancel401,
  PostApiV1CourseregistrationEnrollmentCancel500,
} from "../../types/courseRegistrationEnrollmentController/PostApiV1CourseregistrationEnrollmentCancel.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1CourseregistrationEnrollmentCancel } from "../../clients/courseRegistrationEnrollmentController/postApiV1CourseregistrationEnrollmentCancel.ts";

export const postApiV1CourseregistrationEnrollmentCancelMutationKey = () =>
  [{ url: "/api/v1/courseregistration/enrollment/cancel" }] as const;

export type PostApiV1CourseregistrationEnrollmentCancelMutationKey = ReturnType<
  typeof postApiV1CourseregistrationEnrollmentCancelMutationKey
>;

export function postApiV1CourseregistrationEnrollmentCancelMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiV1CourseregistrationEnrollmentCancelMutationRequest>
  > & { client?: Client } = {},
) {
  const mutationKey = postApiV1CourseregistrationEnrollmentCancelMutationKey();
  return mutationOptions<
    PostApiV1CourseregistrationEnrollmentCancelMutationResponse,
    ResponseErrorConfig<
      | PostApiV1CourseregistrationEnrollmentCancel400
      | PostApiV1CourseregistrationEnrollmentCancel401
      | PostApiV1CourseregistrationEnrollmentCancel500
    >,
    { data?: PostApiV1CourseregistrationEnrollmentCancelMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return postApiV1CourseregistrationEnrollmentCancel(data, config);
    },
  });
}

/**
 * @description Altera o status da matrícula para Cancelado em Inscrição (CanceledInRegistration), cancela todas as parcelas em aberto do plano financeiro principal ativo e recusa o vínculo de bolsa quando aplicável. Os campos StatusReasonId, SubStatusReasonId e Observation são obrigatórios. Requer permissão de empresa sobre a matrícula. **(Requer Authorization para autenticação)**
 * @summary Cancela uma matrícula em inscrição (Requer Authorization para autenticação)
 * {@link /api/v1/courseregistration/enrollment/cancel}
 */
export function usePostApiV1CourseregistrationEnrollmentCancel<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1CourseregistrationEnrollmentCancelMutationResponse,
      ResponseErrorConfig<
        | PostApiV1CourseregistrationEnrollmentCancel400
        | PostApiV1CourseregistrationEnrollmentCancel401
        | PostApiV1CourseregistrationEnrollmentCancel500
      >,
      { data?: PostApiV1CourseregistrationEnrollmentCancelMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiV1CourseregistrationEnrollmentCancelMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiV1CourseregistrationEnrollmentCancelMutationKey();

  const baseOptions =
    postApiV1CourseregistrationEnrollmentCancelMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiV1CourseregistrationEnrollmentCancelMutationResponse,
      ResponseErrorConfig<
        | PostApiV1CourseregistrationEnrollmentCancel400
        | PostApiV1CourseregistrationEnrollmentCancel401
        | PostApiV1CourseregistrationEnrollmentCancel500
      >,
      { data?: PostApiV1CourseregistrationEnrollmentCancelMutationRequest },
      TContext
    >;

  return useMutation<
    PostApiV1CourseregistrationEnrollmentCancelMutationResponse,
    ResponseErrorConfig<
      | PostApiV1CourseregistrationEnrollmentCancel400
      | PostApiV1CourseregistrationEnrollmentCancel401
      | PostApiV1CourseregistrationEnrollmentCancel500
    >,
    { data?: PostApiV1CourseregistrationEnrollmentCancelMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1CourseregistrationEnrollmentCancelMutationResponse,
    ResponseErrorConfig<
      | PostApiV1CourseregistrationEnrollmentCancel400
      | PostApiV1CourseregistrationEnrollmentCancel401
      | PostApiV1CourseregistrationEnrollmentCancel500
    >,
    { data?: PostApiV1CourseregistrationEnrollmentCancelMutationRequest },
    TContext
  >;
}
